export default {
  displayName: 'Locator',
  allowableParents: ['Section'],
};
